/* eslint-disable import/no-anonymous-default-export */
import { GrpStandardScreen } from "../../../layout/grp-standard-screen";
import { GrpSubMenusPathEnum } from "../../../shared/enums/grp-menus.enum";
import useStandardGrpFetch from "../../../shared/hooks/useStandardGrpFetch";

import { Config } from "./config";
import tableColumns from "./components/table-columns";
import zonesParser from "./parsers/zones.parser";

import { CreateInputs, FilterInputs, UpdateInputs } from "./components/inputs";
import { zonesValidator } from "./validators/zones.validator";

export default () => {
    const { content, fetch, loading } = useStandardGrpFetch({
        subMenuPath: GrpSubMenusPathEnum.ZONING,
        config: Config,
    });

    return (
        <GrpStandardScreen
            title="Zonas Urbanas - Tabela de Usos"
            url={Config.api.path}
            columns={tableColumns}
            dataSource={content?.data}
            filters={{ fields: FilterInputs.map((input) => input()) }}
            register={{
                fields: CreateInputs.map((input) => input()),
                validator: zonesValidator,
                parser: zonesParser,
            }}
            update={{
                fields: UpdateInputs.map((input) => input()),
                validator: zonesValidator,
                parser: zonesParser,
            }}
            pagination={content?.paginate}
            loading={loading}
            reFetch={fetch}
        />
    );
};
